import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, Chip, InputAdornment, Modal, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReusableTable from "../../common/table/CommonTable";
import {
  deletePatient,
  fetchPatients,
} from "../../redux/patient/patientAction";

const PatientList = () => {
  const [loading, setLoading] = useState(true);
  const [openDeleteModel, setopenDeleteModel] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteId, setdeleteId] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientList = useSelector(
    (state) => state?.patients?.fetchListPatients || {}
  );
  const [data, setData] = useState([]);
  
  const fetchData = async (page) => {
    setLoading(true);
    await dispatch(fetchPatients(page));
    setLoading(false);
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, dispatch]);

  useEffect(() => {
    if (patientList.data && Array.isArray(patientList.data.data)) {
      const formattedData = patientList.data.data.map((patient) => ({
        ids: patient.patient_serial_no,
        id: patient.id,
        name: patient.patient_name,
        ipNumber: patient.ip_number,
        phone: patient.phone,
        joinDate: patient.createdAt,
        dischargeDate: patient.discharge_date || "N/A",
        status: patient.status || "Active",
      }));
      setData(formattedData);
      setFilteredData(formattedData);
    } else {
      setData([]);
      setFilteredData([]);
    }
  }, [patientList]);

  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredData(data);
    } else {
      const lowercasedTerm = searchTerm.toLowerCase();
      const filtered = data.filter(patient => 
        patient.name?.toLowerCase().includes(lowercasedTerm) ||
        patient.ids?.toString().includes(lowercasedTerm) ||
        patient.ipNumber?.toLowerCase().includes(lowercasedTerm) ||
        patient.phone?.toLowerCase().includes(lowercasedTerm) ||
        (patient.status && patient.status.toLowerCase().includes(lowercasedTerm))
      );
      setFilteredData(filtered);
    }
  }, [searchTerm, data]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const columns = [
    {
      id: "ids",
      label: "Patient ID",
      sortable: true,
      render: (value, row) => (
        <Typography
          component="span"
          sx={{
            cursor: "pointer",
            color: "dodgerblue",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
          onClick={() => handleViewClick(row)}
        >
          {value}
        </Typography>
      ),
    },
    { id: "ipNumber", label: "IP Number", sortable: true },
    { id: "name", label: "Patient Name", sortable: true },
    { id: "phone", label: "Phone", sortable: true },
    {
      id: "joinDate",
      label: "Join Date",
      sortable: true,
      render: (value) => {
        const date = new Date(value);
        return isNaN(date) ? "Invalid Date" : date.toLocaleDateString();
      },
    },
    {
      id: "status",
      label: "Status",
      sortable: true,
      render: (value) => (
        <Chip
          label={value}
          color={value === "Active" ? "success" : "warning"}
        />
      ),
    },
  ];
  const handleViewClick = (row) => {
    navigate(`/patient/view/${row.id}`);
  };
  const handleEditClick = (row) => {
    navigate(`/patient/edit/${row.id}`);
  };

  const handleDeleteClick = (row) => {
    setdeleteId(row.id);
    setopenDeleteModel(true);
  };
  const handleDeleteConfirm = () => {
    setData(data.filter((item) => item.id !== deleteId));
    setFilteredData(filteredData.filter((item) => item.id !== deleteId));
    dispatch(deletePatient(deleteId));
    setopenDeleteModel(false);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const totalPages = patientList.data?.totalPages || 1;

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search patients by name, ID, phone, status..."
          value={searchTerm}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <ReusableTable
        title="Patients"
        columns={columns}
        data={filteredData}
        isLoading={loading}
        headerColor="#000"
        rowColor="#ffffff"
        alternateRowColor="#f5f5f5"
        onViewClick={handleViewClick}
        onEditClick={handleEditClick}
        onDeleteClick={handleDeleteClick}
        withPagination={true}
        withActions={true}
   
        showDownloadOption={true}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
      <Modal
        open={openDeleteModel}
        style={{ left: "35%", top: "35%" }}
        onClose={() => {
          setopenDeleteModel(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ width: "500px", background: " #fff", padding: "20px" }}>
          <Typography
            id="modal-modal-title"
            variant="h5"
            sx={{ fontSize: "large", fontWeight: "500" }}
            component="h2"
          >
            Delete Patient
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Are you sure you want to delete this patient?
          </Typography>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}
          >
            <Button variant="contained" onClick={handleDeleteConfirm}>
              OK
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setopenDeleteModel(false);
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default PatientList;